import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';



@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {

            console.log(err, err.status === 401);

            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authService.removeToken();
                // location.reload(true);
            }

            const error = {
              message: err.error.message || err.statusText,
              errors: err.error.errors || null
            };
            return throwError(error);
        }));
    }
}
